import { Constants } from "common/constants";
import { UserAuthGuard } from "components/authguard/UserAuthGuard";
import { AiMetricsPage } from "pages/aimetrics";
import { RouteObject } from "react-router-dom";

export const AiMetricsRoutes: RouteObject[] = [
  {
    path: "/ai-metrics",
    handle: { pageTitle: "AI Metrics" },
    element: (
      <UserAuthGuard
        component={<AiMetricsPage />}
        anyOf={[
          Constants.AI_METRICS_USERS_GROUP_NAME_VALUE,
          Constants.AI_METRICS_ADMINS_GROUP_NAME_VALUE,
        ]}
      />
    ),
  },
];
